import {
  keepPreviousData,
  useInfiniteQuery,
  useQuery,
} from "@tanstack/react-query";
import { axiosInstance } from "../axios";

export const fetchActivities = async ({
  itemCount,
  pageNumber,
  beforeTimestamp,
  allMembers,
}) => {
  const searchParams = new URLSearchParams();
  if (typeof pageNumber === "number")
    searchParams.append("pageNumber", pageNumber);
  if (typeof itemCount === "number")
    searchParams.append("itemCount", itemCount);
  if (beforeTimestamp) searchParams.append("beforeTimestamp", beforeTimestamp);

  const route = allMembers ? "getAllActivities" : "getActivities";
  const response = await axiosInstance.get(
    `/umbraco/api/activities/${route}?${searchParams}`
  );
  return response.data;
};

export const useRecentActivities = ({
  itemCount,
  pageNumber,
  beforeTimestamp,
  allMembers,
}) => {
  return useQuery({
    queryKey: [
      "recent-activities",
      itemCount,
      pageNumber,
      beforeTimestamp,
      Boolean(allMembers),
    ],
    queryFn: () =>
      fetchActivities({ itemCount, pageNumber, beforeTimestamp, allMembers }),
    placeholderData: keepPreviousData,
  });
};

export const useAllActivities = ({
  itemCount,
  beforeTimestamp,
  allMembers,
}) => {
  return useInfiniteQuery({
    queryKey: [
      "all-activities",
      itemCount,
      beforeTimestamp,
      Boolean(allMembers),
    ],
    queryFn: ({ pageParam = 0 }) =>
      fetchActivities({
        itemCount,
        pageNumber: pageParam,
        beforeTimestamp,
        allMembers,
      }),
    placeholderData: keepPreviousData,
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (!lastPage?.existMore) return undefined;
      return lastPageParam + 1;
    },
    select: (data) => ({
      pages: [...data.pages],
      pageParams: [...data.pageParams],
      allActivities:
        data?.pages
          ?.flatMap((page) => page.activityFeedsList)
          ?.reduce((acc, item) => {
            if (
              !acc.some((existingItem) => existingItem.title === item.title)
            ) {
              acc.push({ ...item });
              return acc;
            } else {
              const existingItem = acc.find(
                (existingItem) => existingItem.title === item.title
              );
              existingItem.activityFeeds = [
                ...existingItem.activityFeeds,
                ...item.activityFeeds,
              ];
              return acc;
            }
          }, []) || [],
    }),
  });
};
